import type { InputPathToValue } from "@octopusdeploy/step-inputs";
import type { ObjectRuntimeInputs } from "@octopusdeploy/step-runtime-inputs";
import { createInputValueAccessor, isNotBoundValue } from "@octopusdeploy/step-runtime-inputs";
import type { CodeEditorComponent, NoteExpression } from "@octopusdeploy/step-ui";
import React, { useEffect, useState } from "react";
import { useScriptActionContext } from "~/components/Actions/script/ScriptActionContext";
import { CodeEditor as BuiltInCodeEditor } from "~/components/CodeEditor/CodeEditor";
import type { InputSummary } from "~/components/StepPackageEditor/Summary/InputSummary";
import { codeEditorVariablesList } from "~/utils/ScriptIntellisense/scriptIntellisense";
export function getCodeEditorSummary<StepInputs>(component: CodeEditorComponent, inputs: ObjectRuntimeInputs<StepInputs>): InputSummary {
    const inputAccessor = createInputValueAccessor(component.input);
    const inputValue = inputAccessor.getInputValue(inputs);
    if (isNotBoundValue(inputValue)) {
        return {
            isDefaultValue: false,
            value: "Expand to edit source code",
        };
    }
    else {
        return {
            isDefaultValue: false,
            value: inputValue.expression,
        };
    }
}
interface CodeEditorProps<StepInputs> {
    configuredStepUIProps: CodeEditorComponent;
    input: InputPathToValue<string>;
    label: string;
    note?: NoteExpression[];
    inputs: ObjectRuntimeInputs<StepInputs>;
    setInputs(inputs: ObjectRuntimeInputs<StepInputs>): void;
    localNames: string[] | undefined;
}
export function CodeEditor<StepInputs>(props: CodeEditorProps<StepInputs>) {
    const inputAccessor = createInputValueAccessor<StepInputs, string>(props.input);
    const inputValue = inputAccessor.getInputValue(props.inputs);
    const value = isNotBoundValue(inputValue) ? inputValue : inputValue.expression;
    const context = useScriptActionContext();
    const [serverNames, setServerNames] = useState<string[]>([]);
    useEffect(() => {
        async function loadServerNames() {
            const sn = (await context?.loadVariables()) ?? [];
            setServerNames(sn);
        }
        loadServerNames();
    }, [context]);
    return (<BuiltInCodeEditor value={value} language={props.configuredStepUIProps.language} localNames={props.localNames} allowFullScreen={true} autoExpand={true} autoComplete={codeEditorVariablesList(serverNames, props.localNames ?? [])} onChange={(newValue) => {
            const updatedInputs = inputAccessor.changeInputValue(props.inputs, newValue);
            props.setInputs(updatedInputs);
        }} showToolbar={true} showCopyButton={true} showInsertVariableButton={true}/>);
}
